<template>

  <div class="mt-2">
    <div class="col">
      <LotNavigation
        :lots="operationLots"
        :current-section.sync="currentSection"
        :lot-prefix="$t('OperationLot')"
        :use-value-property="true"
        :show-new-label="true"
        :new-label="$t('New')"
        :operation-lot-label="$t('operationLot')"
      />
    </div>

    <template v-for="(operationLot, index) in operationLots" v-if="currentSection === index">
      <operation-lot-component
        :key="index"
        :deletable="index > 0"
        :etages="etages"
        :index="index"
        :lot-number="index + 1"
        :operation-lot="operationLot"
        :t-v-a-types="TVATypes"
        :operationType="operationType"
        :types-lot="typesLot"
        :need-schedule="needSchedule"
        :template-schedule="templateSchedule"
        @didChangeValue="emitChangeValue"
        @removedOperationLot="removedOperationLot"/>
    </template>

  </div>

</template>

<script>

import api from '../../../services/api'
import OperationLotComponent from "../components/OperationLotComponent"
import LotNavigation from "../../../components/LotNavigation";

export default {

  name: "OperationLots",

  emits: ['didChangeValue'],

  components: {
    OperationLotComponent,
    LotNavigation
  },

  props: {
    operationId: {
      type: Number,
      default: null
    },
    simulationId: {
      type: Number,
      default: null
    },
    operationType: {
      type: String,
      default: null
    },
    operationLotsIdsToRemove: [],
    operationLots: [],
    needSchedule: {
      type: Boolean,
      default: false
    },
    templateSchedule: {
      type: Object,
      default: null
    },
    overrideCurrentSection: {
      type: Number,
      default: null
    },
    typesLot: {
      type: Array,
      default: function () {
        return []
      }
    },
  },

  data() {
    return {
      etages: [],
      currentSection: 0
    }
  },

  mounted() {
    this.fetchData()
  },

  watch: {
    overrideCurrentSection(newValue) {
      if (newValue !== null) {
        this.currentSection = newValue
      }
    },
  },

  methods: {

    async fetchData() {
      await this.getTVATypes()
      await this.getEtages()
      await this.getOperationLots()
      if (this.operationLots.length === 0) {
        this.addOperationLot()
      }
    },

    async getTVATypes() {
      await api
        .get(`/operationLot/getTVATypes`)
        .then(response => {
          this.TVATypes = response.data
        })
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },


    async getEtages() {
      await api
        .get(`/operationLot/getEtages`)
        .then(response => {
          this.etages = response.data
        })
    },

    async getOperationLots() {
      if (this.operationId != null) {
        await this.getOperationLotsFromOperation()
      } else if (this.simulationId != null) {
        await this.getOperationLotsFromSimulation()
      }
    },

    async getOperationLotsFromOperation() {
      await api
        .get(`/operationLot/getAllForOperation/${this.operationId}`)
        .then(response => {
          response.data.forEach(lot => {

            let debutConstruction = null
            if (lot.debutConstruction) {
              debutConstruction = new Date(lot.debutConstruction).toLocaleDateString().split("/").reverse().join("-")
            }

            let finConstruction = null
            if (lot.finConstruction) {
              finConstruction = new Date(lot.finConstruction).toLocaleDateString().split("/").reverse().join("-")
            }

            let sspVente = null
            if (lot.sspVente) {
              sspVente = new Date(lot.sspVente).toLocaleDateString().split("/").reverse().join("-")
            }

            let acteVente = null
            if (lot.acteVente) {
              acteVente = new Date(lot.acteVente).toLocaleDateString().split("/").reverse().join("-")
            }

            let pretAcheteur = null
            if (lot.pretAcheteur) {
              pretAcheteur = new Date(lot.pretAcheteur).toLocaleDateString().split("/").reverse().join("-")
            }

            let depotPermis = null
            if (lot.depotPermis) {
              depotPermis = new Date(lot.depotPermis).toLocaleDateString().split("/").reverse().join("-")
            }

            let accordPermis = null
            if (lot.accordPermis) {
              accordPermis = new Date(lot.accordPermis).toLocaleDateString().split("/").reverse().join("-")
            }

            let dateFinBail = null
            if (lot.dateFinBail) {
              dateFinBail = new Date(lot.dateFinBail).toLocaleDateString().split("/").reverse().join("-")
            }

            let dateButoirResiliation = null
            if (lot.dateButoirResiliation) {
              dateButoirResiliation = new Date(lot.dateButoirResiliation).toLocaleDateString().split("/").reverse().join("-")
            }

            this.operationLots.push({
              id: lot.id,
              name: {state: null, invalidFeedback: null, value: lot.name},
              prixParM2: {state: null, invalidFeedback: null, value: lot.prixParM2},
              prixVenteTTC: {state: null, invalidFeedback: null, value: lot.prixVenteTTC},
              typeLot: {state: null, invalidFeedback: null, value: lot.typeLot.value},
              surface: {state: null, invalidFeedback: null, value: lot.surface},
              etage: {state: null, invalidFeedback: null, value: lot.etage.value},
              lotCoPro: {state: null, invalidFeedback: null, value: lot.lotCoPro},
              comment: {state: null, invalidFeedback: null, value: lot.comment},
              isLotVir: {state: null, invalidFeedback: null, value: lot.isLotVir},
              percentageTreso: {state: null, invalidFeedback: null, value: lot.percentageTreso},
              debutConstruction: {
                state: null,
                invalidFeedback: null,
                value: debutConstruction
              },
              finConstruction: {
                state: null,
                invalidFeedback: null,
                value: finConstruction
              },
              acteVente: {
                state: null,
                invalidFeedback: null,
                value: acteVente
              },
              sspVente: {
                state: null,
                invalidFeedback: null,
                value: sspVente
              },
              realDate: {state: null, invalidFeedback: null, value: lot.realDate},
              realDateSSP: {state: null, invalidFeedback: null, value: lot.realDateSSP},
              pretAcheteur: {state: null, invalidFeedback: null, value: pretAcheteur},
              depotPermis: {state: null, invalidFeedback: null, value: depotPermis},
              accordPermis: {state: null, invalidFeedback: null, value: accordPermis},
              isLoue: {state: null, invalidFeedback: null, value: lot.isLoue},
              nomLocataire: {state: null, invalidFeedback: null, value: lot.nomLocataire},
              dateFinBail: {state: null, invalidFeedback: null, value: dateFinBail},
              dateButoirResiliation: {state: null, invalidFeedback: null, value: dateButoirResiliation},
              loyersPercus: {state: null, invalidFeedback: null, value: lot.loyersPercus},
              tauxTVA: {state: null, invalidFeedback: null, value: lot.tauxTVA},
              schedule: {state: null, invalidFeedback: null, value: lot.schedule},
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getOperationLotsFromSimulation() {
      await api
        .get(`/simulationLot/getAllForSimulation/${this.simulationId}`)
        .then(response => {
          response.data.forEach(lot => {
            this.operationLots.push({
              name: {state: null, invalidFeedback: null, value: lot.name},
              prixParM2: {state: null, invalidFeedback: null, value: lot.prixParM2},
              prixVenteTTC: {state: null, invalidFeedback: null, value: lot.prixVenteTTC},
              typeLot: {state: null, invalidFeedback: null, value: lot.typeLot.value},
              surface: {state: null, invalidFeedback: null, value: lot.surface},
              lotCoPro: {state: null, invalidFeedback: null, value: null},
              etage: {state: null, invalidFeedback: null, value: null},
              comment: {state: null, invalidFeedback: null, value: null},
              isLotVir: {state: null, invalidFeedback: null, value: false},
              debutConstruction: {state: null, invalidFeedback: null, value: null},
              finConstruction: {state: null, invalidFeedback: null, value: null},
              acteVente: {state: null, invalidFeedback: null, value: null},
              sspVente: {state: null, invalidFeedback: null, value: null},
              realDate: {state: null, invalidFeedback: null, value: null},
              realDateSSP: {state: null, invalidFeedback: null, value: null},
              percentageTreso: {state: null, invalidFeedback: null, value: null},
              pretAcheteur: {state: null, invalidFeedback: null, value: null},
              depotPermis: {state: null, invalidFeedback: null, value: null},
              accordPermis: {state: null, invalidFeedback: null, value: null},
              isLoue: {state: null, invalidFeedback: null, value: lot.isLoue},
              nomLocataire: {state: null, invalidFeedback: null, value: null},
              dateFinBail: {state: null, invalidFeedback: null, value: null},
              dateButoirResiliation: {state: null, invalidFeedback: null, value: null},
              loyersPercus: {state: null, invalidFeedback: null, value: lot.loyersPercus},
              schedule: {state: null, invalidFeedback: null, value: null},
              tauxTVA: {state: null, invalidFeedback: null, value: lot.tauxTVA}
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    addOperationLot() {
      this.operationLots.push({
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        prixParM2:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        prixVenteTTC:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        typeLot:
          {
            state: null,
            invalidFeedback: null,
            value: this.typesLot[0].value
          },
        surface:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lotCoPro:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        etage:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        comment:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        debutConstruction: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        finConstruction: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        acteVente: {state: null, invalidFeedback: null, value: null},
        sspVente: {state: null, invalidFeedback: null, value: null},
        realDate: {state: null, invalidFeedback: null, value: null},
        realDateSSP: {state: null, invalidFeedback: null, value: null},
        percentageTreso: {state: null, invalidFeedback: null, value: null},
        pretAcheteur: {state: null, invalidFeedback: null, value: null},
        depotPermis: {state: null, invalidFeedback: null, value: null},
        accordPermis: {state: null, invalidFeedback: null, value: null},
        isLoue: {state: null, invalidFeedback: null, value: false},
        nomLocataire: {state: null, invalidFeedback: null, value: null},
        dateFinBail: {state: null, invalidFeedback: null, value: null},
        dateButoirResiliation: {state: null, invalidFeedback: null, value: null},
        loyersPercus: {state: null, invalidFeedback: null, value: null},
        tauxTVA: {state: null, invalidFeedback: null, value: null},
        isLotVir: {state: null, invalidFeedback: null, value: false},
        schedule: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      })
    },

    removedOperationLot(operationLot) {
      if (operationLot.id) {
        this.operationLotsIdsToRemove.push(operationLot.id)
      }
      this.operationLots.splice(this.operationLots.indexOf(operationLot), 1)
      this.currentSection = this.currentSection > 0 ? this.currentSection - 1 : 0
    },

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operation/components/OperationLots.vue